import {connect} from '@gisatcz/ptr-state';
import Presentation from './presentation';
import Select from '../../../../../../../../state/Select';

const mapStateToProps = (state, ownProps) => {
	return {
		data: Select.worldWater.statistics?.getWpChartData(
			state,
			ownProps.store,
			ownProps.chartKey,
			ownProps.sources,
			ownProps.isMultiselect
		),
		dataType: Select.components.get(state, ownProps.chartKey, 'dataType'),
	};
};

const mapDispatchToProps = () => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Presentation);
